import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down\">\n  <g clip-path=\"url(#icon-down_clip0_6124_31)\">\n    <path d=\"M8 10.334L4 6.33398H12L8 10.334Z\" fill=\"#F53F3F\" />\n  </g>\n  <defs>\n    <clipPath id=\"icon-down_clip0_6124_31\">\n      <rect width=\"16\" height=\"16\" fill=\"white\" transform=\"translate(16 16) rotate(180)\" />\n    </clipPath>\n  </defs>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol